import { TriangleAlert } from "lucide-react";

/**
 * Full-bleed outage notice shown above the header in Portus (P-2469).
 *
 * Purely presentational. `message` is free-form operator text that arrives
 * verbatim from the API, so it is rendered as a plain React text child — never
 * `dangerouslySetInnerHTML`, no markdown, no link parsing. It also needs no
 * translation key: it is data, not copy.
 *
 * `role="status"` + `aria-live="polite"` on purpose. The value is re-fetched
 * every 60 seconds, and `role="alert"` (assertive) would make screen readers
 * re-interrupt the user on every poll.
 *
 * Long messages wrap and the bar grows; there is no truncation.
 */
export const ServiceBanner = ({ message }: { message: string }) => (
  <div
    role="status"
    aria-live="polite"
    className="flex w-full items-center justify-center gap-2 bg-destructive px-4 py-2 text-center text-sm font-medium text-destructive-foreground"
  >
    <TriangleAlert className="size-4 shrink-0" aria-hidden="true" />
    <span>{message}</span>
  </div>
);
